module.exports = __webpack_public_path__ + "assets/94dcc975aaf39f45050a77555d5a74f0.wav";